/* BuysBest cards: homepage extras, wishlist/compare state sync, mobile compare bar */
(function(){
  var MAX=4;
  function ls(k){try{return JSON.parse(localStorage.getItem(k)||'[]')||[]}catch(e){return []}}
  function cmp(){return ls('compareItem')}

  /* ---- homepage bestsellers: brand / badges for cards not rendered by the section itself ---- */
  function homepage(){
    var panels=document.querySelectorAll('.bsell__panel[data-panel]');
    if(!panels.length||!window.fetch) return;
    panels.forEach(function(panel){
      var cards=panel.querySelectorAll('.bcard:not([data-bbk])');
      if(!cards.length) return;
      fetch('/collections/'+encodeURIComponent(panel.getAttribute('data-panel'))+'?view=bbmeta')
        .then(function(r){return r.ok?r.text():Promise.reject()})
        .then(function(t){
          var d=JSON.parse(t).p||{};
          cards.forEach(function(c){
            var m=(c.getAttribute('href')||'').match(/\/products\/([^/?#]+)/);
            var x=m&&d[decodeURIComponent(m[1])];
            if(!x||c.getAttribute('data-bbk')) return;
            c.setAttribute('data-bbk','1');
            var img=c.querySelector('.bcard__img'),name=c.querySelector('.bcard__name');
            var b='';
            if(x.o>0) b+='<span class="bbk-badge bbk-badge--sale">-'+x.o+'%</span>';
            if(x.l>0&&x.l<=5) b+='<span class="bbk-badge bbk-badge--low">Only '+x.l+' left</span>';
            if(b&&img){var w=document.createElement('span');w.className='bbk-badges';w.innerHTML=b;img.appendChild(w);}
            if(x.b&&name){var p=document.createElement('span');p.className='bbk-brand';p.textContent=x.b;name.parentNode.insertBefore(p,name);}
          });
        }).catch(function(){});
    });
  }

  /* ---- keep hearts / compare ticks in sync with saved lists (also for cards loaded later) ---- */
  function sync(){
    var wl=ls('wishlistItem'),cl=cmp();
    document.querySelectorAll('.bbk-wish[data-wishlist-handle]').forEach(function(b){
      b.classList.toggle('wishlist-added',wl.indexOf(b.getAttribute('data-wishlist-handle'))>-1);
    });
    document.querySelectorAll('.bbk-cmp').forEach(function(w){
      var h=w.getAttribute('data-product-compare-handle'),on=cl.indexOf(h)>-1,
          lab=w.querySelector('.compare-button'),inp=w.querySelector('input');
      if(inp) inp.checked=on;
      if(lab) lab.classList.toggle('is-checked',on);
    });
    bar();
  }

  /* ---- toast ---- */
  var toast,tt;
  function say(msg){
    if(!toast){toast=document.createElement('div');toast.className='bbk-toast';toast.setAttribute('role','status');document.body.appendChild(toast);}
    toast.textContent=msg;toast.classList.add('is-on');clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('is-on')},2200);
  }

  /* ---- compare bar (phones/tablets) ---- */
  var barEl;
  function build(){
    if(barEl||!document.querySelector('.bbk-cmp')) return;
    barEl=document.createElement('div');barEl.className='bbk-cmpbar';barEl.setAttribute('role','region');barEl.setAttribute('aria-label','Compare products');
    barEl.innerHTML='<div class="bbk-cmpbar__msg" aria-live="polite"></div>'+
      '<button type="button" class="bbk-cmpbar__go" data-compare-link><div class="loading__spinner hidden"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg></div><span>Compare</span></button>'+
      '<button type="button" class="bbk-cmpbar__clr" aria-label="Clear compare list"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    document.body.appendChild(barEl);
    barEl.querySelector('.bbk-cmpbar__clr').addEventListener('click',function(){
      var el=document.querySelector('compare-product-popup');
      try{ if(el&&el.compareItems) el.compareItems.splice(0); localStorage.setItem('compareItem','[]'); if(el&&el.updateCounterCompare) el.updateCounterCompare(); }catch(e){}
      sync();
    });
    bar();
  }
  function bar(){
    if(!barEl) return;
    var n=cmp().length,msg=barEl.querySelector('.bbk-cmpbar__msg'),go=barEl.querySelector('.bbk-cmpbar__go');
    barEl.classList.toggle('is-on',n>0);
    if(n===1){msg.innerHTML='<b>1 product</b> selected<br>Pick one more to compare';go.disabled=true;}
    else if(n>1){msg.innerHTML='<b>'+n+' products</b> ready to compare';go.disabled=false;}
  }

  /* limit to MAX so the comparison stays readable on small screens */
  document.addEventListener('change',function(e){
    var t=e.target;
    if(t&&t.matches&&t.matches('[data-product-compare] input')&&t.checked&&cmp().length>=MAX){
      t.checked=false;e.stopImmediatePropagation();say('You can compare up to '+MAX+' products at a time');
    }
  },true);
  document.addEventListener('change',function(e){
    if(e.target&&e.target.matches&&e.target.matches('[data-product-compare] input')) setTimeout(function(){sync()},0);
  });
  document.addEventListener('click',function(e){
    if(e.target.closest&&e.target.closest('.bbk-wish')) setTimeout(sync,0);
  });

  function init(){
    homepage();build();sync();
    if(window.MutationObserver){
      var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(function(){build();sync()},150)}).observe(document.body,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
